import { render, staticRenderFns } from "./superiorSubsidyRecord.vue?vue&type=template&id=47bb9638&scoped=true&"
import script from "./superiorSubsidyRecord.vue?vue&type=script&lang=js&"
export * from "./superiorSubsidyRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47bb9638",
  null
  
)

export default component.exports